import React, { FC, useMemo } from 'react';
import { useScopedSelector } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { setNotificationsIsOpened } from '../../actions/Notifications.actions';
import Drawer from './Drawer';
import { StyledNotificationButton } from './NotificationsIcon.styles';
import NotificationsCountResource, { NotificationsCountResourceInfo } from '../NotificationsCountResource/NotificationsCountResource';
import PromotionLoader from '../_PromotionLoader';
import { Notification } from '../../interfaces/Notification';

export interface NotificationsIconProps { }

const NotificationsIcon: FC<NotificationsIconProps> = () => {
  const count: number = useScopedSelector(NotificationsCountResourceInfo.dataDst, 0);
  const promotions: Notification[] = useScopedSelector('/App.features.notifications.promotions', []);
  const filteredPromotions = useMemo(() => promotions?.filter((notification) => notification.id !== 'IA_CLIENT_SPACE'), [promotions]);
  const dispatch = useDispatch();
  const totalCount = useMemo(() => (count + (filteredPromotions?.length ?? 0)), [filteredPromotions, count]);

  return (
    <>
      <PromotionLoader />
      <NotificationsCountResource autoRequest />
      <StyledNotificationButton maxCount={99} onClick={() => dispatch(setNotificationsIsOpened())} name="/App.features.notifications.notificationButton">
        {totalCount === 0 ? null : totalCount}
      </StyledNotificationButton>
      <Drawer />
    </>
  );
};
export default NotificationsIcon;
